import { TextInfoWithImage } from 'shared/components/TextInfoWithImage';
import { Wrapper } from 'shared/components/Wrapper';
import { DESCRIPTION } from './constants';
import { Title } from 'shared/components/Title';
import { Block } from 'shared/components/Block';
import { Element } from 'react-scroll';
import { ENavigation } from 'shared/types/navigation';
import { Cybersecurity } from '../Cybersecurity';

export const ToolsForDevelopers: React.FC = () => {
  return (
    <div>
      <Wrapper>
        <Element name={ENavigation.ForDevelopers}>
          <Block>
            <Title text="Инструменты для девелоперов и финансовых организаций" maxWidth={420} />
            <TextInfoWithImage description={DESCRIPTION} image="graphic" title="Данные и аналитика" />
          </Block>
        </Element>
        <Block>
          <Cybersecurity />
        </Block>
      </Wrapper>
    </div>
  );
};
